








































































































import Vue, { PropType } from "vue"
import PTopBoard from "./items/PTopBoard.vue"
import PInputRequestArea from "./myPage/PInputRequestArea.vue"
import PBaseInfo from "./items/PBaseInfo.vue"
import PSkillTag from "./items/PSkillTag.vue"
import PPublicStatusModal from "./myPage/PPublicStatusModal.vue"
import PSocialLinks from "./items/PSocialLinks.vue"
import PCareers from "./items/PCareers.vue"
import PCapabilities from "./items/PCapabilities.vue"
import PPortfolio from "./items/PPortfolio.vue"
import PSupplementaryExplanation from "./items/PSupplementaryExplanation.vue"
import PSelfIntroduction from "./items/PSelfIntroduction.vue"
import PPhilosophy from "./items/PPhilosophy.vue"
import PBoundaryLine from "./items/PBoundaryLine.vue"
import { OutputOGP } from "~/backendApis/viewModel/common"
import { StandardApplicationError } from "~/errorHandlers"
import { userProfileInputRequestLogics } from "~/uiLogics/userProfileInputRequest"
import { BackendApi } from "~/backendApis"
import { PublicStatus } from "~/backendApis/request/user/userProfile/write/ChangePublicStatusWriteRequest"
import {
  decorateUserProfileSearchResultView,
  UserContactInformationView,
  OnboardingStatusView,
  decorateOnboardingStatusView,
  FullInfoUserProfileView,
} from "~/backendApis/viewModel"

const profilePublishSettingOnboardingStage = "profile_publish_setting"

export default Vue.extend({
  components: {
    PTopBoard,
    PInputRequestArea,
    PBaseInfo,
    PSkillTag,
    PPublicStatusModal,
    PSocialLinks,
    PCareers,
    PCapabilities,
    PPortfolio,
    PSupplementaryExplanation,
    PSelfIntroduction,
    PPhilosophy,
    PBoundaryLine,
  },
  props: {
    userProfile: {
      type: Object as PropType<FullInfoUserProfileView>,
      required: true,
    },
    userContactInformation: {
      type: Object as PropType<UserContactInformationView>,
      default: null,
    },
  },
  data() {
    return {
      isVisiblePublicStatuModal: false,
      isVisiblePublishSettingOnboardingModal: false,
    }
  },
  computed: {
    userProfileDecorator(): ReturnType<
      typeof decorateUserProfileSearchResultView
    > {
      return decorateUserProfileSearchResultView(this.userProfile)
    },
    mainCorporationName(): string | undefined {
      return decorateUserProfileSearchResultView(
        this.userProfile
      ).getMainExperienceCorporation()?.corporationName
    },
    mainCorporationEnrolledStatus(): boolean | undefined {
      return decorateUserProfileSearchResultView(
        this.userProfile
      ).getMainExperienceCorporation()?.isCurrentCorporation
    },
    userProfileInputRequest() {
      return this.userContactInformation
        ? userProfileInputRequestLogics().getRequest(
            this.userProfile,
            this.userContactInformation
          )
        : null
    },
    outputOGPs(): OutputOGP[] {
      return this.userProfileDecorator.getOutputOGPs()
    },
  },
  mounted(): void {
    this.userProfileDecorator.loadOutputOGPs()
    this.initIsVisiblePublishSettingOnboardingModal()
  },
  methods: {
    initIsVisiblePublishSettingOnboardingModal() {
      BackendApi.User.UserAccount.read
        .getCurrentUserOnboardingStatus()
        .then((fetchedOnboardingStatus) => {
          this.openModalIfUnfinishOnboarding(fetchedOnboardingStatus)
        })
    },
    openModalIfUnfinishOnboarding(onboardingStatus: OnboardingStatusView) {
      if (
        decorateOnboardingStatusView(
          onboardingStatus
        ).isFinishedProfilePublishSettingOnboarding()
      ) {
        return
      }

      this.openProfilePublishSettingOnboardingModal()
    },
    handleClickCareerDeleteButton(index: number) {
      this.$emit("click-career-delete-button", index)
    },

    async updatePublicStatus(status: PublicStatus) {
      if (!this.$clAuth.loggedIn) {
        throw new StandardApplicationError("現在の認証情報が不正です")
      }

      await new BackendApi.User.UserProfile.ChangePublicStatusWriteRequest({
        status,
      }).post()

      this.$clAuth.refreshAuthState()

      this.$clStores.flashMessage.actions.drawFlashSuccess(
        "公開ステータスを更新しました"
      )
      this.closePublicStatuModal()
    },
    openPublicStatuModal() {
      this.isVisiblePublicStatuModal = true
    },
    closePublicStatuModal() {
      this.isVisiblePublicStatuModal = false
    },
    openProfilePublishSettingOnboardingModal() {
      this.isVisiblePublishSettingOnboardingModal = true
    },
    // モーダルを閉じてからバックエンドにオンボーディング完了の情報を保存する。
    hidePublishSettingOnboardingModal(): void {
      this.isVisiblePublishSettingOnboardingModal = false

      BackendApi.User.UserAccount.write.achieveOnboardingStage({
        finishedStage: profilePublishSettingOnboardingStage,
      })
    },
    handleClickSettingsIcon(): void {
      this.$router.push("/user/account_setting")
    },
    handleClickInputRequest(): void {
      if (this.userProfileInputRequest) {
        this.$router.push(this.userProfileInputRequest.formPagePath)
      }
    },
  },
})
